import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-12 col-md-3" }
const _hoisted_4 = { class: "col-sm-12 col-md-9 content" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { style: {"text-align":"center"} }, "Ищем подходящие туры"),
  /*#__PURE__*/_createElementVNode("h4", { style: {"text-align":"center"} }, "Это не займет много времени")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (i) => {
          return _createElementVNode("div", {
            class: "col-12 loadingItem mb-3",
            style: {"height":"70px","border-radius":"7px"},
            key: i
          })
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (index) => {
          return _createElementVNode("div", {
            class: "item loadingItem",
            key: index
          })
        }), 64))
      ])
    ])
  ]))
}